import { useTranslation } from 'react-i18next';
import * as React from 'react';
import { Answers, ChoiceField, ListField } from './types/form';
import ChoiceFieldQuestion from './ChoiceFieldQuestion';
import ListFieldQuestion from './ListFieldQuestion';
import HelpTextModal from './HelpTextModal';

type QuestionProps = {
    answer?: string | string[];
    field: ChoiceField | ListField;
    setAnswers: React.Dispatch<React.SetStateAction<Answers>>;
    id:
        | 'area'
        | 'house_age'
        | 'house_type'
        | 'house_isolation'
        | 'energy_source'
        | 'heating_type';
    icons?: { [key: string]: string };
};

export default function Question({
    answer = undefined,
    field,
    setAnswers,
    id,
    icons = undefined,
}: QuestionProps) {
    const { t } = useTranslation();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    return (
        <fieldset>
            <legend>{t(field.label)}</legend>

            <HelpTextModal
                isOpen={modalIsOpen}
                setIsOpen={setModalIsOpen}
                content={field.help_text}
            />

            <div className="form-option__heading">
                <h2 className="heading-beta form-option__title nomargin">
                    {t(field.label)}
                </h2>
                <button type="button" onClick={() => setModalIsOpen(true)}>
                    {t('?')}
                </button>
            </div>

            <ul className="form-options">
                {field.type === 'choice' && (
                    <ChoiceFieldQuestion
                        answer={answer as string | undefined}
                        field={field}
                        id={id}
                        setAnswers={setAnswers}
                        icons={icons}
                    />
                )}
                {field.type === 'list' && (
                    <ListFieldQuestion
                        answer={answer as string[] | undefined}
                        field={field}
                        id={id}
                        setAnswers={setAnswers}
                        icons={icons}
                    />
                )}
            </ul>
        </fieldset>
    );
}
